import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAdminAuth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('adminAuthenticated');
    
    if (!isAuthenticated || isAuthenticated !== 'true') {
      // Redirect to admin login if not authenticated
      navigate('/admin/login');
    }
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem('adminAuthenticated');
    localStorage.removeItem('adminEmail');
    navigate('/admin/login');
  };

  const getAdminEmail = () => {
    const storedEmail = localStorage.getItem('adminEmail');
    // If stored email is the old one, update it
    if (storedEmail === 'admin@trucknsendit.com') {
      localStorage.setItem('adminEmail', 'info@trucknsendit.com');
      return 'info@trucknsendit.com';
    }
    return storedEmail || 'info@trucknsendit.com';
  };

  return { logout, getAdminEmail };
};

export default useAdminAuth;
